import { render, staticRenderFns } from "./customProfileCommand.vue?vue&type=template&id=2cddba90"
import script from "./customProfileCommand.vue?vue&type=script&lang=js"
export * from "./customProfileCommand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports